import { Add } from '@material-ui/icons';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useRef, useState } from 'react';
import { ASSET_URL, ENVIRONMENT } from '../../../env/Configurations';
import { getPreSignedUrl } from '../../../utils/PropertyAPIUtils';
import './Icon-Picker.scss';
import { convertFileToBase64, sanitizeFileName } from '../../../utils/commonUtils';
import { notificationManager } from '../../../utils/NotificationUtils';

const IconPicker = (props) => {
  const { format, height, width, matrix, onIconSelect, iconURL, groupId, imageDetail, error } =
    props;
  const [isSizeExceeded, setSizeExceeded] = useState(false);
  const [uploadError, setUploadError] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [dimensionError, setDimensionError] = useState(false);
  const [namingError, setNamingError] = useState(false);
  const inputFile = useRef(null);
  const onImageSelectorClick = () => {
    inputFile?.current?.click();
  };

  const removeImage = () => {
    const iconUrl = {
      value: '',
      fieldName: 'Icon',
      errors: {},
      validations: [],
      tab: 0,
    };
    onIconSelect(iconUrl);
  };

  const handleImageSelect = async (e) => {
    const fileObj = e.target.files[0];
    setNamingError(false);
    setDimensionError(false);
    if (fileObj) {
      if (fileObj.type !== 'image/svg+xml') {
        setNamingError(true);
        removeImage();
      } else {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          var imageObj = new Image();
          imageObj.src = reader.result;
          imageObj.onload = async () => {
            if (imageObj.height > height || imageObj.width > width) {
              setDimensionError(true);
              return removeImage();
            }
            setDimensionError(false);
            if (fileObj.size / 1024 / 1024 < 10) {
              setIsUploading(true);
              setSizeExceeded(false);

              if (fileObj) {
                convertFileToBase64(fileObj)
                  .then(async (base64) => {
                    const input = {
                      type: 'hambuger_menu_item',
                      groupId: groupId,
                      propertyType: 'hambuger-menu-item',
                      contentLength: fileObj.size,
                      contentType: fileObj.type,
                      filename: sanitizeFileName(fileObj.name),
                      skipContentValidation: false,
                      contents: base64,
                    };

                    try {
                      const res = await getPreSignedUrl(input);

                      if (res?.data?.getPreSignUrlCMS?.key) {
                        const iconUrl = {
                          value: res.data.getPreSignUrlCMS.key,
                          fieldName: 'Icon',
                          errors: {},
                          validations: [],
                          tab: 0,
                        };
                        onIconSelect(iconUrl);
                        setIsUploading(false);
                        setUploadError(false);
                        setNamingError(false);
                      } else {
                        setUploadError(true);
                        setIsUploading(false);
                      }
                    } catch (error) {
                      setIsUploading(false);

                      if (ENVIRONMENT === 'dev') {
                        console.log(error?.message);
                      }

                      if (error?.message) {
                        notificationManager(
                          'danger',
                          error?.message?.replace('GraphQL error:', ''),
                        );
                      } else {
                        notificationManager('danger', 'Error while uploading file.');
                      }
                    }
                  })
                  .catch((error) => {
                    if (ENVIRONMENT === 'dev') {
                      console.log(error?.message, 'error');
                    }

                    notificationManager('danger', 'Error converting file to base64');
                  });
              }
            } else {
              setSizeExceeded(true);
            }
          };
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    }
  };

  return (
    <div className='col-12 icon-picker'>
      <div className='row'>
        <div className='col-4'>
          <div className='icon-drop-zone'>
            {isUploading ? (
              <div className='d-flex align-items-center icon-select justify-content-center'>
                <CircularProgress />
              </div>
            ) : (
              <div
                onClick={onImageSelectorClick}
                className='d-flex align-items-center icon-select justify-content-center'
              >
                {iconURL ? (
                  <div className='icon-container'>
                    <img src={ASSET_URL + iconURL} alt='SelectedImage' />
                  </div>
                ) : (
                  <>
                    <Add fontSize='large' />
                  </>
                )}
                <input
                  type='file'
                  onChange={handleImageSelect}
                  accept='image/svg+xml'
                  id='file'
                  ref={inputFile}
                  style={{ display: 'none' }}
                />
              </div>
            )}
          </div>
        </div>
        <div className='col-8 d-flex flex-column justify-content-end'>
          <div className='d-flex row px-2'>
            {isSizeExceeded && (
              <span className='size-exceeded mt-3'> The maximum file size is 10mb</span>
            )}
            {uploadError && <span className='size-exceeded mt-3'> Image uploading failed</span>}
            {namingError && (
              <span className='size-exceeded mt-2'>Please upload icon in SVG format.</span>
            )}
            {dimensionError && (
              <span className='size-exceeded mt-1'>
                {' '}
                Sorry! Unable to add Image with dimension more than {width} X {height}
              </span>
            )}
          </div>
          <div className='d-flex px-2'>
            <div className='icon-details label'>Format :</div>
            <div className='icon-details'>{format}</div>
          </div>
          <div className='d-flex px-2'>
            <div className='icon-details label'>Dimension :</div>
            <div className='icon-details'>
              {width} * {height}
              {matrix} {imageDetail}
            </div>
          </div>
          {iconURL && (
            <div onClick={removeImage} className='px-2 mt-2 pointer icon-details text-underlined'>
              Remove Image
            </div>
          )}
        </div>
      </div>
      {uploadError ? (
        <></>
      ) : (
        error && (
          <div>
            <p className='error-text'>Image required</p>
          </div>
        )
      )}
    </div>
  );
};

export default IconPicker;
